// Массив с периодом лет
export const yearsArr = (endMinusCountYears, startYearConst) => {
  const years = [];
  const startYear = startYearConst || 1980;
  for (let i = endMinusCountYears; i > startYear; i -= 1) {
    years.push(i);
  }
  return years;
};

// Колво дней в конкретном месяце TODO Проверить использование и удалить
export const daysInMonth = (month, year) => new Date(year, month, 0).getDate();

// Колво дней в конкретном месяце
export const getDaysInMonth = (month, year) => {
  const date = new Date(year, month - 1, 1);
  const days = [];
  while (date.getMonth() === month - 1) {
    days.push(new Date(date).getDate());
    date.setDate(date.getDate() + 1);
  }
  return days;
};

export const getDateDifference = (date1, date2) => {
  // Преобразуем даты в UTC
  const utcDate1 = new Date(
    Date.UTC(
      date1.getFullYear(),
      date1.getMonth(),
      date1.getDate(),
      date1.getHours(),
      date1.getMinutes()
    )
  );
  const utcDate2 = new Date(
    Date.UTC(
      date2.getFullYear(),
      date2.getMonth(),
      date2.getDate(),
      date2.getHours(),
      date2.getMinutes()
    )
  );

  // Вычисляем разницу в миллисекундах
  let diffInMs = Math.abs(utcDate2 - utcDate1);

  // Разница в годах
  const years = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 365));
  diffInMs -= years * 1000 * 60 * 60 * 24 * 365;

  // Разница в днях
  const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  diffInMs -= days * 1000 * 60 * 60 * 24;

  // Разница в часах
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  diffInMs -= hours * 1000 * 60 * 60;

  // Разница в минутах
  const minutes = Math.floor(diffInMs / (1000 * 60));

  return { years, days, hours, minutes };
};

export const getDateDifferenceInDays = (date1, date2) => {
  // Приводим обе даты к началу дня
  const startOfDay1 = new Date(
    date1.getFullYear(),
    date1.getMonth(),
    date1.getDate()
  );
  const startOfDay2 = new Date(
    date2.getFullYear(),
    date2.getMonth(),
    date2.getDate()
  );

  // Вычисляем разницу в миллисекундах
  const diffInMs = Math.abs(startOfDay2 - startOfDay1);

  // Конвертируем миллисекунды в дни
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
};

export const getMaxDate = dates => {
  if (!Array.isArray(dates) || dates.length === 0) {
    throw new Error('Empty dates');
  }

  return new Date(Math.max(...dates.map(date => new Date(date).getTime())));
};



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/otherHelpers.js